const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

/**
 * Submit Contact Form
 */
const submitContact = async (contactData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw data || { message: "Failed to send message" };
    }

    return data;
  } catch (error) {
    throw error.message ? error : { message: "Failed to send message" };
  }
};

const getAllContactMessages = async () => {
  const response = await fetch(
    `${API_BASE_URL}/contactAll`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

const updateContactStatus = async (id, status) => {
  const response = await fetch(
    `${API_BASE_URL}/messages/${id}/status`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};

export { submitContact, getAllContactMessages , updateContactStatus};